<script>
import * as THREE from 'three'
import * as d3 from 'd3'
import atBatBalls from '@/threePositions2.js'
import multiBalls from '@/multiBall.js'
import setting from '@/setting'
import pitchJS from '@/pitchTunnel.js'
import common from '@/common.js'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'
import {mapGetters, mapState} from "vuex";


export default {
    name: 'ThreeDee',
    props: ['vsDataClickedBall', 'initMode', 'from'],
    emits: ['modal3d-off'],
    data() {
        return {
            atBatBalls,
            multiBalls,
            trajectoryDatas: {},
            positions: [],
            multiPositions: [],
            enableMultiPos: [],
            selectedBalls: [],
            mode: '',
            atBatInitial: true,
            compareInitial: true,
            playing: false,
            frameRate: 16,
            ball: {
                id: '',
                gameId: '',
                inning: '',
                paofinning: '',
                pitchofpa: '',
                pitcher: {
                    id: '',
                    uniform_number: '',
                    name: ''
                },
                team: {
                    id: '',
                    name: ''
                },
                batter: {
                    id: '',
                    uniform_number: '',
                    name: ''
                },
                vsTeam: {
                    id: '',
                    name: ''
                },
                data: {
                    pitchofpa: '',
                    pitchingdata: {
                        TaggedPitchType: '',
                        RelSpeed: 0,
                        SpinRate: 0,
                        Balls: 0,
                        Strikes: 0,
                        Outs: 0
                    }
                },
                ballColor: '#ffffff',
                enabled: true
            },
            allBalls: null,
            // 比較球
            savedBalls: [],
            currentSavedBallsId: [],
            pichiTunnelCompare: [], // ピッチトンネル比較球
            // 基準球
            savedStandardBall: [],
            currentSavedStandardBallId: [],
            pichiTunnelBase: [], // ピッチトンネル基準球
            // 基準球の比較球配列中の位置
            baseBallIndex: 0,
            // ピッチトンネル比較モードレビュー球
            PTReviewBalls: [],
            PTReviewStandardBall: [],
            threeListSortMode: 0,
            // バッターボックス描画頂点
            batterBoxVertices: [
                {x: 0, y: 0, z: 0},
                {x: 7, y: 0, z: 0},
                {x: 114.92, y: 0, z: 0},
                {x: 121.92, y: 0, z: 0},
                {x: 121.92, y: 0, z: 7},
                {x: 121.92, y: 0, z: 175.88},
                {x: 121.92, y: 0, z: 182.88},
                {x: 114.92, y: 0, z: 182.88},
                {x: 7, y: 0, z: 182.88},
                {x: 0, y: 0, z: 182.88},
                {x: 0, y: 0, z: 175.88},
                {x: 0, y: 0, z: 7},
                {x: 7, y: 0, z: 7},
                {x: 114.92, y: 0, z: 7},
                {x: 114.92, y: 0, z: 175.88},
                {x: 7, y: 0, z: 175.88}
            ],
            threeParts: {
                intervalID: null,
                scene: new THREE.Scene(), // シーン
                camera: null,
                orbitControls: null,
                renderer: new THREE.WebGLRenderer({antialias: true}),  // レンダラー
                // directionalLight: new THREE.DirectionalLight(0xffffff, 3), // 光源
                directionalLight: new THREE.AmbientLight(0xffffff), // 光源
                ballGeometry: new THREE.SphereGeometry(3.65, 32, 32),  // 球のジオメトリ
                ballMaterial: new THREE.MeshLambertMaterial({color: 0xffffff}), // 球のマテリアル
                lineMaterial: new THREE.LineBasicMaterial({color: 0xffff00, linewidth: 1}), // 軌跡線のマテリアル
                timerID: null,
                mesh: null,
                nowID: null,
                nowMesh: null,  // コマ送り用メッシュ(single)
                nowMeshes: [],  // コマ送り用メッシュ(multi)
                nowFrame: 0,
                nowMaxFrame: 0,
                nowLines: [],
                meshs: [],
                tempPositions: [],
                pichiTunnelMesh: {}, // ピッチトンネル用メッシュ
                homePlateMesh: {}, // ホームプレート用メッシュ
            },
            temp_kinds: [
                '直球',
                '直球',
                '直球',
                'スライダー',
                '直球'
            ],
            temp_kinds2: [
                '直球',
                '直球',
                '直球',
                '直球',
                '直球',
                'スライダー',
                '直球',
                '直球',
                '直球',
                '直球',
                '直球'
            ],
            currentState: null,
            slidex: 0,
            slidey: 0,
            slidez: 0,
            slideBatx: 80,
            slideBaty: 170,
            slideBatz: 1844,
            slidePitx: 0,
            slidePity: 200,
            slidePitz: 0,
            currentBatterPointSet: {
                slideBatPositionXMin: 0,
                slideBatPositionXMax: 0,
                slideBatPositionZMin: 0,
                slideBatPositionZMax: 0,
                slideBatPointMin: 0,
                slideBatPointMax: 0,
                slidePitPositionXMin: 0,
                slidePitPositionXMax: 0,
                slidePitPointMin: 0,
                slidePitPointMax: 0
            },
            currentAngle: 'catcher',
            batterPointSet: {
                // 左打席
                batterLeft: {
                    x: {
                        min: -158.76,
                        max: -36.84
                    },
                    y: {
                        min: 160,
                        max: 200
                    },
                    z: {
                        min: 1730.96,
                        max: 1854
                    }
                },
                // 右打席
                batterRight: {
                    x: {
                        min: 36.84,
                        max: 158.76
                    },
                    y: {
                        min: 160,
                        max: 200
                    },
                    z: {
                        min: 1730.96,
                        max: 1854
                    }
                }
            },
            pitcherPointSet: {
                x: {
                    // min: -30.48,
                    // max: 30.48
                    min: -30,
                    max: 30
                },
                y: {
                    min: 160,
                    max: 200
                }
            },
            batterPanelState: false,
            pitcherPanelState: false,
            // 比較球、基準球検索モーダル
            searchModalFlg: false,
            searchModalType: 'compare',
            // メッセージモーダル
            messageTimeout: null,
            messageModalShow: false,
            message: '',
            // ローディング
            loadingShow: false,
            loadingMessage: '',
            pichiTunnelWidth: 0,
            pichiTunnelZ: 0,
            homeTunnelWidth: 0,
            homeTunnelZ: 0,
            tabData: [],
            tabIndex: 999,
            pt2info: {},
            mountedFlag: true,
        }
    },
    computed: {
        ...mapGetters(['listOfTeams']),
        ballColors () {
            return [].concat(d3.schemeCategory20).concat(d3.schemeCategory20b)
        }
    },
    watch: {
        slideBatx: 'setCustomViewPoint',
        slideBaty: 'setCustomViewPoint',
        slideBatz: 'setCustomViewPoint',
        slidePitx: 'setCustomViewPoint',
        slidePity: 'setCustomViewPoint',
        slidePitz: 'setCustomViewPoint'
    },
    mounted() {
        this.init()

        if (this.mode === 'tunnel') {
            // 基準球と比較球が選ばれてなかったらアラート表示
            setTimeout(() => {
                this.alertBallCountError()
                console.log('mounted hogehogehoge')
            }, 500)
        }
        // 拡大・ダブルクリック防止
        // タップ感度向上のため、ダブルタップは許可するように変更
        // let tapFlag = false
        // let timer = null
        // window.document.body.addEventListener('touchstart', function (evt) {
        //   if (tapFlag) {
        //     evt.preventDefault()
        //   }
        // }, true)

        // window.document.body.addEventListener('touchend', function (evt) {
        //   tapFlag = true
        //   clearTimeout(timer)
        //   timer = setTimeout(function () {
        //     tapFlag = false
        //   }, 400)
        // }, true)
    },
    methods: {
        init () {
            console.log('init')
            this.loadingOn()
            this.currentState = window.location.pathname.split('/')[1]
            if (this.initMode === 'tunnelReview') {
                this.mode = 'compare'
                this.threeListSortMode = 2
            } else {
                this.mode = this.initMode
            }
            this.init_renderer()  // レンダラー
            this.init_camera()  // カメラ
            this.init_orbit() // OrbitControls
            this.init_light() // 光源
            this.init_strikeZone()  // ストライクゾーン
            this.init_mound() // マウンド
            this.init_pitcherPlate()  // ピッチャープレート
            this.init_homeBase()  // ホームベース
            this.init_bases() // 一〜三塁ベース
            this.init_batterBox() // バッターボックス
            this.init_foulLine() // ファウルライン
            this.getOnceSavedBalls()  // localStorageから比較球取得
            // if (this.mode === 'compare') {
            //   this.compare_init()
            // } else {
            //   this.getBallData()  // 基準球情報取得
            //   this.atBat_init() // atBatモード初期処理
            // }
        },
        updateAll () {
            console.log('updateAll')
            this.loadingOn()
            const trajectoryDatas = {}
            this.compareInitial = true
            const savedBalls = this.$ls.get('savedBalls', [])
            if (Array.isArray(savedBalls)) {
                this.savedBalls = savedBalls
            } else {
                this.savedBalls = []
            }
            this.savedBalls.forEach((d) => {
                trajectoryDatas[d.data.pitchingdata.PitchUID] = null
            })
            this.savedStandardBall = this.$ls.get('savedStandardBalls')
            this.savedStandardBall.forEach((d) => {
                trajectoryDatas[d.data.pitchingdata.PitchUID] = null
            })
            if (this.allBalls !== null) {
                this.allBalls.forEach((d) => {
                    trajectoryDatas[d.data.pitchingdata.PitchUID] = null
                })
            }
            this.trajectoryDatas = trajectoryDatas
            console.log('trajectoryDatas initialized:', trajectoryDatas)
            this.getSavedBallIds()
            this.getSavedStandardBallIds()

            if (this.mode === 'atBat') {
                this.atBat_init()
            } else {
                this.compare_init()
            }

            let allBalls = []
            if (this.allBalls !== null) {
                allBalls = [].concat(this.savedBalls).concat(this.savedStandardBall).concat(this.allBalls)
            } else {
                allBalls = [].concat(this.savedBalls).concat(this.savedStandardBall)
            }
            this.getPitchesData('updateAll', this.trajectoryDatas, allBalls)
        },
        // モーダルOFF
        modal3dOff () {
            this.$emit('modal3d-off')
        },
        // 基準球情報取得
        getBallData () {
            console.log('getBallData', this.vsDataClickedBall)
            let that = this
            // 投球IDから投球情報取得
            if (typeof this.vsDataClickedBall !== 'undefined') {
                this.ball.data = this.vsDataClickedBall.allData // 投球データ
                this.ball.gameId = this.vsDataClickedBall.allData.game_id
                this.ball.inning = this.vsDataClickedBall.allData.inning
                this.ball.paofinning = this.vsDataClickedBall.allData.paofinning
                this.ball.team.id = this.vsDataClickedBall.allData.pitchingdata.PitcherTeam // 自チームID
                this.ball.pitcher.id = this.vsDataClickedBall.allData.pitchingdata.PitcherId // 投手ID
                this.ball.vsTeam.id = this.vsDataClickedBall.allData.pitchingdata.BatterTeam // 対戦チームID
                this.ball.batter.id = this.vsDataClickedBall.allData.pitchingdata.BatterId // 対戦打者ID

                // ○球目を定義（データで○球目（pitchofpa）が合っていないケースがあったので、ここで再定義）
                this.vsDataClickedBall.atBatDataList.forEach((d, index) => {
                    if (this.vsDataClickedBall.allData.id === d.id) {
                        this.$set(this.threeParts, 'nowID', index)
                    }
                })

                const players = this.$p.get(this.ball.team.id)
                console.log(this.ball.team.id,this.ball.pitcher.id,players)
                // 投手の情報取得
                const pitcher = players[this.ball.pitcher.id]
                this.ball.pitcher.name = pitcher.name
                this.ball.pitcher.uniform_number = pitcher.additional?.uniform_number ?? '999'
                // 自チームの情報取得
                this.ball.team.name = this.listOfTeams[this.ball.team.id].name_short2
                // 対戦打者の情報取得
                const playersVs = this.$p.get(this.ball.vsTeam.id)
                const batter = playersVs[this.ball.batter.id]
                this.ball.batter.name = batter.name
                this.ball.batter.uniform_number = batter.additional?.uniform_number ?? '999'
                // 対戦チームの情報取得
                this.ball.vsTeam.name = this.listOfTeams[this.ball.vsTeam.id].name_short2
                // 打席リスト（API取得ではなくvsDataから引き回したデータを使用）
                this.vsDataClickedBall.atBatDataList.forEach((d, i) => {
                    this.trajectoryDatas[d.pitchingdata.PitchUID] = null
                })
                let posSortArray = []
                this.vsDataClickedBall.atBatDataList.forEach((d) => {
                    let obj = JSON.parse(JSON.stringify(d))
                    obj.data = {
                        pitchingdata: JSON.parse(JSON.stringify(obj.pitchingdata))
                    }
                    posSortArray.push(obj)
                })
                this.allBalls = [].concat(posSortArray)
                console.log('vsDataの情報からball作成')
                let allBalls = [].concat(this.savedBalls).concat(this.savedStandardBall).concat(this.allBalls)
                this.getPitchesData('getBallData', this.trajectoryDatas, allBalls)
            }
        },
        // 投球IDから詳細情報を取得
        getPitchesData (category, trajectoryDatas, allBalls) {
            console.log('getPitchesData', category, trajectoryDatas, allBalls)
            // let dataLength = Object.keys(data).length
            // let countNum = 0
            if (Object.keys(trajectoryDatas).length === 0) {
                console.log('trajectoryDatas no data')
                this.loadingOff()
                return
            }
            Object.keys(trajectoryDatas).forEach((traID, val) => {
                let data = {}
                allBalls.forEach((d2) => {
                    if (d2.id === traID || d2.data.id === traID) {
                        data = Object.assign({}, d2.data)
                    }
                })
                let trajectoryArray = []
                if (Object.keys(data).length === 0) {
                    return
                }
                let nineParam = data.pitchingdata.NineParam
                let zoneTimeMax = (data.pitchingdata.NineParam.ZoneTime + 0.016) * 1000 | 0
                for (let i = 0; i < zoneTimeMax; i += 16 | 0) {
                    let pos = {}
                    if (zoneTimeMax - i > 16) {
                        pos.Time = Math.floor(i) / 1000
                    } else {
                        pos.Time = data.pitchingdata.NineParam.ZoneTime
                    }
                    pos.x = nineParam.ax0 * Math.pow(pos.Time, 2) + nineParam.vx0 * pos.Time + nineParam.x0
                    pos.y = nineParam.ay0 * Math.pow(pos.Time, 2) + nineParam.vy0 * pos.Time + nineParam.y0
                    pos.z = nineParam.az0 * Math.pow(pos.Time, 2) + nineParam.vz0 * pos.Time + nineParam.z0
                    trajectoryArray.push(pos)
                }
                let tmpArray = []
                trajectoryArray.forEach((d) => {
                    tmpArray.push({
                        t: d.Time,
                        x: d.x,
                        y: d.z,
                        z: 18.44 - d.y
                    })
                })
                this.$set(this.trajectoryDatas, data.pitchingdata.PitchUID, tmpArray)
            })
            // console.log('trajectoryDatas', that.trajectoryDatas)
            console.log('trajectoryDatas ready')
            if (category === 'getOnceSavedBalls') {
                window.setTimeout(this.loadingOff, 1500)
            } else {
                this.loadingOff()
            }
        },
        // レンダラー初期処理
        init_renderer () {
            // レンダラーのサイズは当初設定したwidthとheightと同じに
            this.threeParts.renderer.setPixelRatio(window.devicePixelRatio)
            this.threeParts.renderer.setSize(this.setting.width, this.setting.height)
            // レンダラーを追加
            this.$refs.threeArea.appendChild(this.threeParts.renderer.domElement)
            console.log('レンダラー初期化完了')
        },
        // カメラ初期処理
        init_camera () {
            let aspect = this.setting.width / this.setting.height // カメラ縦横比
            // カメラとその位置を設定
            this.$set(this.threeParts, 'camera', new THREE.PerspectiveCamera(this.setting.fov, aspect, this.setting.near, this.setting.far))
            this.threeParts.camera.position.set(0, 78.6384, 2050)
            // カメラをシーンに追加
            this.threeParts.scene.add(this.threeParts.camera)
        },
        // OrbitControls初期処理
        init_orbit () {
            this.threeParts.orbitControls = new OrbitControls(this.threeParts.camera, this.threeParts.renderer.domElement)
            this.threeParts.orbitControls.addEventListener('change', (e) => {
                console.log('OrbitControls change', e)
                this.render(e)
            })
            this.threeParts.orbitControls.enableDamping = true
            this.threeParts.orbitControls.dampingFactor = 0.25
            this.threeParts.orbitControls.zoomSpeed = 0.07
            this.threeParts.orbitControls.rotateSpeed = 0.07
            this.threeParts.orbitControls.minPolarAngle = 0
            this.threeParts.orbitControls.maxPolarAngle = Math.PI / 2
            this.threeParts.orbitControls.target = new THREE.Vector3(0, 78.6384, 922)
        },
        // 光源初期処理
        init_light () {
            // 光源を設定
            this.threeParts.directionalLight.position.z = 3
            // 光源をシーンに追加
            this.threeParts.scene.add(this.threeParts.directionalLight)
        },
        // PT2遷移時の処理
        movePT2Search () {
            const tabData = this.$ls.get(setting.sessionKey.pt1Tabs)
            const data = tabData.data[tabData.index]
            if (tabData.index === 999) {
                this.$ls.set(setting.sessionKey.pt2Search, {})
            } else {
                // PT2検索情報
                this.$ls.set(setting.sessionKey.pt2Search, data.PT2Search)
            }
            if (data.PT2 === 'H') {
                // PT2Hのゾーン選択等
                this.$ls.set(setting.sessionKey.pt2HomeBallContent, data.PT2Others.PT2HomeBallContent)
                // PT2Hのシークバー
                this.$ls.set(setting.sessionKey.pt2ChangeAmountThresholdSeekBar, data.PT2Others.PT2ChangeAmountThresholdSeekBar)
                // PT2Hの選択された投球1
                this.$ls.set(setting.sessionKey.pt2ConfirmationChangeAmountBall1, data.PT2Others.PT2ConfirmationChangeAmountBall1)
                // PT2Hの選択された投球2
                this.$ls.set(setting.sessionKey.pt2ConfirmationChangeAmountBall2, data.PT2Others.PT2ConfirmationChangeAmountBall2)
            } else if (data.PT2 === 'S') {
                // PT2Sのシークバー
                this.$ls.set(setting.sessionKey.pt2S1ThresholdSeekBar, data.PT2Others.PT2S1ThresholdSeekBar)
                // PT2Sの選択された投球1
                this.$ls.set(setting.sessionKey.pt2SSelectedBall1, data.PT2Others.PT2SSelectedBall1)
                // PT2Sの選択された投球2
                this.$ls.set(setting.sessionKey.pt2SSelectedBall2, data.PT2Others.PT2SSelectedBall2)
            }
            this.$router.push('PitchiTunnelSearch')
        },
        // ストライクゾーン設定
        init_strikeZone () {
            let planeGeo = new THREE.PlaneGeometry(60.96, 59.7408, 32)
            let planeMate = new THREE.MeshLambertMaterial({color: 0x999999, transparent: true, opacity: 0.3})
            let plane = new THREE.Mesh(planeGeo, planeMate)
            plane.position.set(0, 78.6384, 1810)
            this.threeParts.scene.add(plane)
        },
        // マウンド(目安)
        init_mound () {
            let circle = new THREE.Mesh(
                new THREE.CircleGeometry(274.3, 100),
                new THREE.MeshLambertMaterial({color: 0x999999, side: THREE.DoubleSide})
            )
            circle.position.set(0, 1, 45.72)
            circle.rotation.x = Math.PI / 2
            this.threeParts.scene.add(circle)
        },
        // ピッチャープレート
        init_pitcherPlate () {
            let pitcherPlateGeom = new THREE.Geometry()
            pitcherPlateGeom.vertices = [
                new THREE.Vector3(-30.45, 2, -15.2),
                new THREE.Vector3(30.45, 2, -15.2),
                new THREE.Vector3(30.45, 2, 0),
                new THREE.Vector3(-30.45, 2, 0)
            ]
            pitcherPlateGeom.faces.push(new THREE.Face3(0, 1, 2))
            pitcherPlateGeom.faces.push(new THREE.Face3(2, 3, 0))
            pitcherPlateGeom.computeFaceNormals()
            this.threeParts.scene.add(new THREE.Mesh(
                pitcherPlateGeom,
                new THREE.MeshLambertMaterial({color: 0x999999, side: THREE.DoubleSide})
            ))
        },
        // ホームベース
        init_homeBase () {
            let geom = new THREE.Geometry()
            geom.vertices = [
                new THREE.Vector3(-21.6, 1, 1800.8),
                new THREE.Vector3(21.6, 1, 1800.8),
                new THREE.Vector3(21.6, 1, 1822.4),
                new THREE.Vector3(-21.6, 1, 1800.8),
                new THREE.Vector3(21.6, 1, 1822.4),
                new THREE.Vector3(-21.6, 1, 1822.4),
                new THREE.Vector3(-21.6, 1, 1822.4),
                new THREE.Vector3(21.6, 1, 1822.4),
                new THREE.Vector3(0, 1, 1844)
            ]
            geom.faces = [
                new THREE.Face3(0, 1, 2),
                new THREE.Face3(3, 4, 5),
                new THREE.Face3(6, 7, 8)
            ]
            geom.computeFaceNormals()
            let mate = new THREE.MeshLambertMaterial({color: 0x999999, side: THREE.DoubleSide})
            let mesh = new THREE.Mesh(geom, mate)
            this.threeParts.scene.add(mesh)
        },
        // 一〜三塁ベース
        init_bases () {
            // 一塁ベース
            let firstBase = new THREE.Mesh(
                new THREE.PlaneGeometry(38.099, 38.099),
                new THREE.MeshLambertMaterial({color: 0x999999, side: THREE.DoubleSide})
            )
            firstBase.position.set(1913, 0.2, -96)
            firstBase.rotation.x = Math.PI / 2
            firstBase.rotation.z = Math.PI / 4
            this.threeParts.scene.add(firstBase)

            // 二塁ベース
            let SecondBase = new THREE.Mesh(
                new THREE.PlaneGeometry(38.099, 38.099),
                new THREE.MeshLambertMaterial({color: 0x999999, side: THREE.DoubleSide})
            )
            SecondBase.position.set(0, 0.1, -2035.5)
            SecondBase.rotation.x = Math.PI / 2
            SecondBase.rotation.z = Math.PI / 4
            this.threeParts.scene.add(SecondBase)

            // 三塁ベース
            let thirdBase = new THREE.Mesh(
                new THREE.PlaneGeometry(38.099, 38.099),
                new THREE.MeshLambertMaterial({color: 0x999999, side: THREE.DoubleSide})
            )
            thirdBase.position.set(-1913, 0.2, -96)
            thirdBase.rotation.x = Math.PI / 2
            thirdBase.rotation.z = Math.PI / 4
            this.threeParts.scene.add(thirdBase)
        },
        // バッターボックス
        init_batterBox () {
            let boxY = 0.2
            let boxLeftGeom = new THREE.Geometry()
            let baseLeftPoint = {x: 36.84, z: 1730.96}
            let boxRightGeom = new THREE.Geometry()
            let baseRightPoint = {x: -158.76, z: 1730.96}

            // 左打席
            boxLeftGeom.vertices.vertices = []
            this.batterBoxVertices.forEach((d, i) => {
                boxLeftGeom.vertices.push(new THREE.Vector3(d.x + baseLeftPoint.x, d.y + boxY, d.z + baseLeftPoint.z))
            })
            boxLeftGeom.faces = [
                new THREE.Face3(0, 3, 4),
                new THREE.Face3(4, 11, 0),
                new THREE.Face3(4, 6, 7),
                new THREE.Face3(7, 13, 4),
                new THREE.Face3(7, 9, 10),
                new THREE.Face3(10, 14, 7),
                new THREE.Face3(10, 11, 12),
                new THREE.Face3(12, 15, 10)
            ]
            boxLeftGeom.computeFaceNormals()
            this.threeParts.scene.add(new THREE.Mesh(
                boxLeftGeom,
                new THREE.MeshLambertMaterial({color: 0x999999, side: THREE.DoubleSide})
            ))
            // 右打席
            boxRightGeom.vertices.vertices = []
            this.batterBoxVertices.forEach((d, i) => {
                boxRightGeom.vertices.push(new THREE.Vector3(d.x + baseRightPoint.x, d.y + boxY, d.z + baseRightPoint.z))
            })
            boxRightGeom.faces = [
                new THREE.Face3(0, 3, 4),
                new THREE.Face3(4, 11, 0),
                new THREE.Face3(4, 6, 7),
                new THREE.Face3(7, 13, 4),
                new THREE.Face3(7, 9, 10),
                new THREE.Face3(10, 14, 7),
                new THREE.Face3(10, 11, 12),
                new THREE.Face3(12, 15, 10)
            ]
            boxRightGeom.computeFaceNormals()
            this.threeParts.scene.add(new THREE.Mesh(
                boxRightGeom,
                new THREE.MeshLambertMaterial({color: 0x999999, side: THREE.DoubleSide})
            ))
        },
        // ファウルライン
        init_foulLine () {
            // ファウルライン(一塁線)
            let foulLineFirstGeom = new THREE.Geometry()
            foulLineFirstGeom.vertices = [
                new THREE.Vector3(110, 0.1, 1734),
                new THREE.Vector3(93, 0.1, 1737),
                new THREE.Vector3(2993, 0.1, -1163),
                new THREE.Vector3(3000, 0.1, -1156)
            ]
            foulLineFirstGeom.faces = [
                new THREE.Face3(0, 1, 2),
                new THREE.Face3(2, 3, 0)
            ]
            foulLineFirstGeom.computeFaceNormals()
            this.threeParts.scene.add(new THREE.Mesh(
                foulLineFirstGeom,
                new THREE.MeshLambertMaterial({color: 0x999999, side: THREE.DoubleSide})
            ))

            // ファウルライン(三塁線)
            let foulLineThirdGeom = new THREE.Geometry()
            foulLineThirdGeom.vertices = [
                new THREE.Vector3(-110, 0.1, 1734),
                new THREE.Vector3(-93, 0.1, 1737),
                new THREE.Vector3(-2993, 0.1, -1163),
                new THREE.Vector3(-3000, 0.1, -1156)
            ]
            foulLineThirdGeom.faces = [
                new THREE.Face3(0, 1, 2),
                new THREE.Face3(2, 3, 0)
            ]
            foulLineThirdGeom.computeFaceNormals()
            this.threeParts.scene.add(new THREE.Mesh(
                foulLineThirdGeom,
                new THREE.MeshLambertMaterial({color: 0x999999, side: THREE.DoubleSide})
            ))
        },
        atBat_init () {
            console.log('atBat_init')
            this.clear()
            this.compareInitial = true
            if (this.threeParts.nowID === null) {
                this.threeParts.nowID = 0
                this.threeParts.nowMaxFrame = this.atBatBalls[this.threeParts.nowID].length - 1
                this.selectedBalls.push(this.atBatBalls[this.threeParts.nowID])
            }
            let array = []
            if (this.allBalls !== null) {
                this.allBalls.forEach((d) => {
                    array.push(d.id)
                })
            }
            common.LOG('INFO', '3D軌跡 打席モード トップ', array)
        },
        compare_init () {
            console.log('compare_init')
            let that = this
            this.clear()
            this.threeParts.nowID = null
            if (this.compareInitial) {
                this.savedBalls.forEach((d, i) => {
                    d.ballColor = that.ballColors[i]
                    // d.enabled = true
                })
                this.compareInitial = false
            }
            common.LOG('INFO', '3D軌跡 比較モード トップ')
        },
        /**
         * function
         * @description ptフラグの初期化処理
         **/
        ptFlag_init () {
            // PT計算対象にするかどうかの初期化用フラグ
            this.savedBalls.forEach( d =>{
                if (d.ptFlag === undefined) {
                    d.ptFlag = true
                }
            })
            if (this.savedStandardBall[0] === undefined) return
            if (this.savedStandardBall[0].ptFlag === undefined) {
                this.$set(this.savedStandardBall[0], 'ptFlag', true)
            }
        },
        /**
         * function
         * @description 比較モードに存在するかチェック
         **/
        compareExistCheck () {
            const compareBall2s = this.$ls.get('savedBalls')
            if (Array.isArray(compareBall2s) && compareBall2s.length > 0) {
                const compareIds = compareBall2s.map((d) => d.data.id)
                this.savedBalls.forEach((d) => {
                    d.compareExist = !!compareIds.includes(d.data.id)
                })
            }



            const baseBall = this.$ls.get('savedStandardBalls')
            if (this.savedStandardBall.length === 0) return
            if (baseBall.length === 0) {
                this.savedStandardBall[0].compareExist = false
                return
            }
            this.savedStandardBall[0].compareExist = this.savedStandardBall[0].data.id === baseBall[0].data.id

        },
        tunnel_init () {
            console.log('tunnel_init')
            common.LOG('INFO', '3D軌跡 ピッチトンネルモード トップ')
            this.clear()
            this.compareInitial = true
            this.threeParts.nowID = null
            this.ptFlag_init()
            this.compareExistCheck()
            this.tab_init()
            this.tabData = this.$ls.get(setting.sessionKey.pt1Tabs)
            this.savedBalls.forEach(d => {
                d.ballColor = setting.typesOfBall_3d[d.data.pitchingdata.TaggedPitchType].fill
            })
            if (this.savedStandardBall.length !== 0) {
                this.savedStandardBall[0].ballColor = setting.typesOfBall_3d[this.savedStandardBall[0].data.pitchingdata.TaggedPitchType].fill
            }
            if (this.tabData.index === 999) return
            this.pt2info = new pitchJS(this.tabData.data[this.tabIndex].PT2Search, this.$root, false)

            // 基準球速度割合
            this.savedStandardBall.forEach((data) => {
                const speed = Math.round(data.data.pitchingdata.RelSpeed / 1000 * 10) / 10
                data.data.pitchingdata.avgSpeed = Math.round(speed / this.pt2info.avgSpeed[data.data.pitchingdata.TaggedPitchType] * 1000) / 10 + '%'
            })
            // 比較球速度表示
            this.savedBalls.forEach(data => {
                const speed = Math.round(data.data.pitchingdata.RelSpeed / 1000 * 10) / 10
                data.data.pitchingdata.avgSpeed = Math.round(speed / this.pt2info.avgSpeed[data.data.pitchingdata.TaggedPitchType] * 1000) / 10 + '%'
            })
        },
        /**
         * function
         * @description 何番目のタブを読み込むか
         **/
        tab_init () {
            this.getTabindex()
            const tabData = this.$ls.get(setting.sessionKey.pt1Tabs)
            if (this.tabIndex === 999 || tabData.data[this.tabIndex] == null) {
                this.tabIndex = 999
                tabData.index = 999
                this.$ls.set(setting.sessionKey.pichiTunnelBase, {})
                this.$ls.set(setting.sessionKey.pichiTunnelCompar, {})
                this.$ls.set(setting.sessionKey.pt1Tabs, tabData)
            } else {
                const tabData = this.$ls.get(setting.sessionKey.pt1Tabs).data
                this.$ls.set(setting.sessionKey.pichiTunnelBase, tabData[this.tabIndex].savedStandardBalls)
                this.$ls.set(setting.sessionKey.pichiTunnelCompar, tabData[this.tabIndex].savedBalls)
            }
        },
        getTabindex () {
            this.tabIndex = this.$ls.get(setting.sessionKey.pt1Tabs).index
        },
        setTabIndex (index) {
            this.tabData.index = index
            this.$ls.set(setting.sessionKey.pt1Tabs, this.tabData)
        },
        changeTab (index) {
            this.setTabIndex(index)
            this.tunnel_init()
            this.getOnceSavedBalls()
        },
        deleteTab (index) {
            const ptData = this.$ls.get(setting.sessionKey.pt1Tabs)
            ptData.data.splice(index, 1)
            this.tabData = ptData
            this.$ls.set(setting.sessionKey.pt1Tabs, ptData)
        },
        remove () {
            this.removePichiTunnel()
            this.removeMeshes()
            this.removeLines()
            this.render()
        },
        removePichiTunnel () {
            console.log('removePichi')
            if (Object.keys(this.threeParts.pichiTunnelMesh).length !== 0) {
                this.threeParts.scene.remove(this.threeParts.pichiTunnelMesh)
            }
            if (Object.keys(this.threeParts.homePlateMesh).length !== 0) {
                this.threeParts.scene.remove(this.threeParts.homePlateMesh)
            }
        },
        removeMeshes () {
            this.threeParts.scene.remove(this.threeParts.nowMesh)
            this.threeParts.nowMeshes.forEach (d => {
                this.threeParts.scene.remove(d)
            })
            this.threeParts.nowMesh = null
            this.threeParts.nowMeshes = []
            this.selectedBalls.forEach(d => {
                this.threeParts.scene.remove(d.mesh)
            })
        },
        removeLines () {
            this.threeParts.nowLines.forEach((d, i) => {
                this.threeParts.scene.remove(d)
            })
            this.render()
        },
        // 描画
        render () {
            console.log('render')
            this.threeParts.renderer.render(this.threeParts.scene, this.threeParts.camera)
        },
        // メッシュがあれば削除→再描画
        clear () {
            return new Promise((resolve) => {
                this.threeParts.nowFrame = 0
                this.threeParts.nowMaxFrame = 0
                this.remove()
                this.render()
                window.setTimeout(() => {
                    resolve()
                }, 100)
            })
        },
        // スライダー操作時
        rangeInput (v) {
            this.threeParts.nowFrame = v
            this.viewFrame()
        },
        // 指定フレームの座標にメッシュ描画
        viewFrame () {
            // this.selectedBalls.forEach(function (d, i) {
            //   that.threeParts.scene.remove(d.mesh)
            // })
            // this.removeMeshes()
            // メッシュを作成
            // this.threeParts.nowMeshes = []
            this.selectedBalls.forEach((d, i) => {
                if (typeof d.positions[this.threeParts.nowFrame] !== 'undefined') {
                    this.threeParts.scene.remove(d.mesh)
                    this.threeParts.scene.remove(this.threeParts.nowMeshes[i])
                    // this.threeParts.nowMeshes[i] = new THREE.Mesh(this.threeParts.ballGeometry, new THREE.MeshLambertMaterial({color: d.ballColor}))
                    this.threeParts.nowMeshes[i] = d.mesh
                    this.threeParts.nowMeshes[i].position.set(
                        d.positions[this.threeParts.nowFrame].x * 100,
                        d.positions[this.threeParts.nowFrame].y * 100,
                        d.positions[this.threeParts.nowFrame].z * 100
                    )
                    this.threeParts.scene.add(this.threeParts.nowMeshes[i])
                    this.threeParts.nowLines[i].geometry.setDrawRange(0, this.threeParts.nowFrame + 1)
                }
            })
            this.threeParts.orbitControls.update()
            this.render()
        },
        // カメラ位置変更
        changeCameraPos (x, y, z) {
            this.threeParts.camera.position.set(x, y, z)
            this.threeParts.orbitControls.update()
            this.render()
        },
        changeLookAt (x, y, z) {
            this.threeParts.camera.lookAt({'x': x, 'y': y, 'z': z})
            this.threeParts.orbitControls.update()
            this.render()
        },
        // カメラ回転のtarget座標変更
        changeOrbitTarget (x, y, z) {
            this.threeParts.orbitControls.target = new THREE.Vector3(x, y, z)
            this.threeParts.orbitControls.update()
            this.render()
        },
        singlePitch (index = this.threeParts.nowID) {
            console.log('singlePitch')
            let obj = {}
            let balls = this.mode === 'compare' ? this.multiBalls : this.atBatBalls
            this.clear()
            this.threeParts.nowFrame = 0
            if (this.mode === 'atBat') {
                balls = []
                if (this.allBalls === null) {
                    return false
                }
                this.allBalls.forEach((d) => {
                    balls.push(this.trajectoryDatas[d.id])
                })
                this.ball.data = this.allBalls[index]
                this.threeParts.nowID = index
            }
            this.selectedBalls = []
            obj.positions = [].concat(balls[index])
            obj.playPositions = [].concat(balls[index])
            obj.mesh = new THREE.Mesh(this.threeParts.ballGeometry, this.threeParts.ballMaterial)
            this.selectedBalls.push(obj)
            let geom = new THREE.BufferGeometry()
            let maxPoints = 999
            let positions = new Float32Array(maxPoints * 3)
            geom.setAttribute('position', new THREE.BufferAttribute(positions, 3))
            let arr = geom.attributes.position.array
            let cnt = 0
            console.log('selected ball positions:', obj.positions)
            obj.positions.forEach((d, i) => {
                arr[cnt] = d.x * 100
                arr[cnt + 1] = d.y * 100
                arr[cnt + 2] = d.z * 100
                cnt += 3
            })
            geom.addGroup(0, 2, 0)
            this.threeParts.nowLines = []
            let line = new THREE.Line(geom, this.threeParts.lineMaterial)
            this.threeParts.nowMaxFrame = obj.positions.length - 1
            this.threeParts.nowLines.push(line)
            this.threeParts.scene.add(line)
            // mode変更
            this.playing = true

            this.pitchRendering()
            if (this.frameRate === 64) {
                common.LOG('INFO', '3D軌跡', 'ユーザー操作/１球スロー再生', this.ball.data.id, this.ball.pitcher.name)
            } else {
                common.LOG('INFO', '3D軌跡', 'ユーザー操作/１球再生', this.ball.data.id, this.ball.pitcher.name)
            }
        },
        multiPitch () {
            console.log('multiPitch', this.threeListSortMode)
            let maxFrame = 0
            this.clear()
            this.threeParts.nowFrame = 0
            this.selectedBalls = []
            this.threeParts.nowLines = []
            let ballIdList = []
            // 比較球でリストが登録順もしくは球種別の場合
            if (this.threeListSortMode < 2) {
                this.savedBalls.forEach((d, i) => {
                    if (d.enabled) {
                        let obj = {}
                        obj.positions = [].concat(this.trajectoryDatas[d.data.id])
                        obj.playPositions = [].concat(this.trajectoryDatas[d.data.id])
                        obj.mesh = new THREE.Mesh(this.threeParts.ballGeometry, new THREE.MeshLambertMaterial({color: d.ballColor}))
                        this.selectedBalls.push(obj)
                        ballIdList.push(d.id)
                        // maxFrame更新
                        if (obj.positions.length > maxFrame) maxFrame = obj.positions.length - 1
                        let geom = new THREE.BufferGeometry()
                        let maxPoints = 150
                        let positions = new Float32Array(maxPoints * 3)
                        geom.setAttribute('position', new THREE.BufferAttribute(positions, 3))
                        let arr = geom.attributes.position.array
                        let cnt = 0
                        console.log('selected ball positions:', obj.positions)
                        obj.positions.forEach((d, i)=> {
                            arr[cnt] = d.x * 100
                            arr[cnt + 1] = d.y * 100
                            arr[cnt + 2] = d.z * 100
                            cnt += 3
                        })
                        geom.addGroup(0, 2, 0)
                        let line = new THREE.Line(geom, new THREE.LineBasicMaterial({color: d.ballColor, linewidth: 1}))
                        this.threeParts.nowLines.push(line)
                        this.threeParts.scene.add(line)
                    }
                })
                // 基準球
                this.savedStandardBall.forEach((d, i) => {
                    if (d.enabled) {
                        let obj = {}
                        obj.positions = [].concat(this.trajectoryDatas[d.data.id])
                        obj.playPositions = [].concat(this.trajectoryDatas[d.data.id])
                        obj.mesh = new THREE.Mesh(this.threeParts.ballGeometry, new THREE.MeshLambertMaterial({color: d.ballColor}))
                        this.selectedBalls.push(obj)
                        ballIdList.push(d.id)
                        // maxFrame更新
                        if (obj.positions.length > maxFrame) maxFrame = obj.positions.length - 1
                        let geom = new THREE.BufferGeometry()
                        let maxPoints = 150
                        let positions = new Float32Array(maxPoints * 3)
                        geom.setAttribute('position', new THREE.BufferAttribute(positions, 3))
                        let arr = geom.attributes.position.array
                        let cnt = 0
                        console.log('selected ball positions:', obj.positions)
                        obj.positions.forEach((d, i) => {
                            arr[cnt] = d.x * 100
                            arr[cnt + 1] = d.y * 100
                            arr[cnt + 2] = d.z * 100
                            cnt += 3
                        })
                        geom.addGroup(0, 2, 0)
                        let line = new THREE.Line(geom, new THREE.LineBasicMaterial({color: d.ballColor, linewidth: 1}))
                        this.threeParts.nowLines.push(line)
                        this.threeParts.scene.add(line)
                    }
                })
            } else {
                // ピッチトンネルレビュー球があれば追加
                if (this.PTReviewBalls.length > 0) {
                    this.PTReviewBalls.forEach((d) => {
                        if (d.enabled) {
                            console.log('PTReviewBall enabled:', JSON.stringify(this.trajectoryDatas))
                            let obj = {
                                positions: this.$copy(this.trajectoryDatas[d.data.id]),
                                playPositions: this.$copy(this.trajectoryDatas[d.data.id]),
                                mesh: new THREE.Mesh(this.threeParts.ballGeometry, new THREE.MeshLambertMaterial({color: d.ballColor}))
                            }
                            this.selectedBalls.push(obj)
                            ballIdList.push(d.id)
                            // maxFrame更新
                            if (obj.positions.length > maxFrame) maxFrame = obj.positions.length - 1
                            let geom = new THREE.BufferGeometry()
                            let maxPoints = 150
                            let positions = new Float32Array(maxPoints * 3)
                            geom.setAttribute('position', new THREE.BufferAttribute(positions, 3))
                            let arr = geom.attributes.position.array
                            let cnt = 0
                            console.log('selected ball positions:', obj.positions)
                            obj.positions.forEach((d, i) => {
                                arr[cnt] = d.x * 100
                                arr[cnt + 1] = d.y * 100
                                arr[cnt + 2] = d.z * 100
                                cnt += 3
                            })
                            geom.addGroup(0, 2, 0)
                            let line = new THREE.Line(geom, new THREE.LineBasicMaterial({
                                color: d.ballColor,
                                linewidth: 1
                            }))
                            this.threeParts.nowLines.push(line)
                            this.threeParts.scene.add(line)
                        }
                    })
                }
                if (this.PTReviewStandardBall.length > 0) {
                    this.PTReviewStandardBall.forEach((d, i) => {
                        if (d.enabled) {
                            let obj = {}
                            obj.positions = [].concat(this.trajectoryDatas[d.data.id])
                            obj.playPositions = [].concat(this.trajectoryDatas[d.data.id])
                            obj.mesh = new THREE.Mesh(this.threeParts.ballGeometry, new THREE.MeshLambertMaterial({color: d.ballColor}))
                            this.selectedBalls.push(obj)
                            ballIdList.push(d.id)
                            // maxFrame更新
                            if (obj.positions.length > maxFrame) maxFrame = obj.positions.length - 1
                            let geom = new THREE.BufferGeometry()
                            let maxPoints = 150
                            let positions = new Float32Array(maxPoints * 3)
                            geom.setAttribute('position', new THREE.BufferAttribute(positions, 3))
                            let arr = geom.attributes.position.array
                            let cnt = 0
                            obj.positions.forEach((d, i) => {
                                arr[cnt] = d.x * 100
                                arr[cnt + 1] = d.y * 100
                                arr[cnt + 2] = d.z * 100
                                cnt += 3
                            })
                            geom.addGroup(0, 2, 0)
                            let line = new THREE.Line(geom, new THREE.LineBasicMaterial({
                                color: d.ballColor,
                                linewidth: 1
                            }))
                            this.threeParts.nowLines.push(line)
                            this.threeParts.scene.add(line)
                        }
                    })
                }
            }
            this.threeParts.nowMaxFrame = maxFrame
            // mode変更
            this.playing = true
            this.threeParts.orbitControls.update()
            this.pitchRendering()
            if (this.frameRate === 64) {
                common.LOG('INFO', '3D軌跡', 'ユーザー操作/マルチスロー再生', ballIdList)
            } else {
                common.LOG('INFO', '3D軌跡', 'ユーザー操作/マルチ再生', ballIdList)
            }
        },
        singleSlow () {
            this.frameRate = 64
            this.singlePitch()
        },
        multiSlow () {
            this.frameRate = 64
            this.multiPitch()
        },
        pitchRendering () {
            console.log('pitchRendering')
            this.selectedBalls.forEach((d, i) => {
                this.threeParts.scene.add(d.mesh)
            })
            if (this.mode === 'tunnel') {
                this.renderingTunnel('pichi')
                //this.renderingTunnel('home')
                this.calcTunnelPointInfo()
            }
            this.pitchAnimate(0)
        },
        /**
         *  function
         *  ピッチトンネル or ホームプレートのメッシュを作成する
         **/
        renderingTunnel (type) {
            // トンネルのレンダリング
            console.log('renderingTunnel' + this.checkAllBallPTflag())
            // 基準球と比較球が選択されている時のみトンネルを描画する
            if (this.savedBalls.length !== 0 && this.savedStandardBall.length !== 0 && this.checkAllBallPTflag()) {
                const target = type === 'pichi' ? 'pichiTunnelMesh' : 'homePlateMesh'
                const ballBasePositions = this.calcBallPositionBymseconds(this.savedStandardBall)
                const ballComparePositions = this.calcBallPositionBymseconds(this.savedBalls)
                const color = type === 'pichi' ? 0xffc373 : 0xe20c16// とりあえず
                const position = this.calcTunnelPosition(ballBasePositions, ballComparePositions, type)
                console.log('position', position)
                const geometry = new THREE.TorusGeometry(position.r, 1, 5, 100, 6.283185307179586)
                const material = new THREE.MeshBasicMaterial({color: color})
                const torus = new THREE.Mesh(geometry, material)
                torus.position.set(position.x, position.y, position.z) // 第1引数がx 第2がy
                this.threeParts.scene.add(torus)
                this.$set(this.threeParts, target, torus)
            } else {
                if (type === 'pichi') this.$alert('PT対象が1球以下です')
            }
        },
        checkAllBallPTflag () {
            const array = this.savedStandardBall.concat(this.savedBalls)
            return array.filter((d) => d.ptFlag).length >= 2
        },
        deleteBall (ballId, type) {
            const tmpCompareBall = this.$ls.get(type)
            tmpCompareBall.forEach((d, i) => {
                if (d.data.id === ballId) {
                    tmpCompareBall.splice(i, 1)
                }
            })
            this.$ls.set(type, tmpCompareBall)
        },
        /**
         * function
         * 渡された基本球と基準球の座標を基にピッチトンネル or ホームプレートの座標オブジェクトを返す
         * @param ballBasePositions {Array<Object>} - 基準球の座標オブジェクの配列
         * @param ballComparePositions
         * @param type
         * @parm ballComparePositions {Array<Object>] - 比較球の座標オブジェクトの配列
         * @parm index {Number} - 175ならピッチトンネル 基準球の添字の最後ならホームプレート
         * @return Object {t,x,y,z,r} - 1ms毎の座標情報の配列
         * */
        calcTunnelPosition (ballBasePositions, ballComparePositions, type) {
            if (!this.checkAllBallPTflag()) {
                return {
                    t: 0,
                    x: 0,
                    y: 0,
                    z: 0,
                    deep: 0,
                    r: 0,
                }
            }

            if (ballBasePositions.length !== 0) ballComparePositions.push(ballBasePositions[0])

            const minIndex = d3.min(ballComparePositions, d => d.length)
            const maxIndex = d3.max(ballComparePositions, d => d.length)
            const fastBallIndex = ballComparePositions.findIndex(d => d.length === minIndex)
            const slowballIndex = ballComparePositions.findIndex(d => d.length === maxIndex)

            const tabData = this.$ls.get(setting.sessionKey.pt1Tabs)
            const pt = tabData.data[tabData.index].PT2 === 'H'
                ? tabData.data[tabData.index].PT2Others.PT2ChangeAmountThresholdSeekBar.ptTime
                : tabData.data[tabData.index].PT2Others.PT2S1ThresholdSeekBar.pt
            const index = type === 'pichi' ? pt : minIndex - 1

            const { xSum, ySum } = ballComparePositions.reduce((acc, d) => {
                const idx = type === 'pichi' ? index : d.length - 1
                acc.xSum += d[idx].x * 100
                acc.ySum += d[idx].y * 100
                return acc
            }, { xSum: 0, ySum: 0 })

            const centerX = xSum / ballComparePositions.length
            const centerY = ySum / ballComparePositions.length
            const ptZ = ballComparePositions[fastBallIndex][index].z
            const r = this.calcDistantBall({ x: centerX, y: centerY }, ballComparePositions, index, type, ptZ)

            const pos = {
                t: ballComparePositions[fastBallIndex][index].Time,
                x: centerX,
                y: centerY,
                z: ballComparePositions[fastBallIndex][index].z * 100,
                deep: ballComparePositions[fastBallIndex][index].z * 100 - ballComparePositions[slowballIndex][index].z * 100,
                r: r
            }

            const ballBaseIndexZ = ballBasePositions[0][index].z
            const ptIndexArray = type === 'pichi' ? ballComparePositions.map(d => {
                return d.reduce((minIdx, d2, i) => Math.abs(ballBaseIndexZ - d2.z) < Math.abs(ballBaseIndexZ - d[minIdx].z) ? i : minIdx, 0)
            }) : []

            const { xx, yy } = ballComparePositions.reduce((acc, d, i) => {
                const idx = type === 'tunnel' || type === 'home' ? d.length - 1 : ptIndexArray[i]
                acc.xx[i] = d[idx].x
                acc.yy[i] = d[idx].y
                return acc
            }, { xx: [], yy: [] })

            return common.getMinimumCircleInfo(xx, yy, pos)
        },
        calcDistantBall(centerPos, ballsPos, index, type, ptZ) {
            const calculateDistance = (x, y) =>
                Math.sqrt((centerPos.x - x * 100) ** 2 + (centerPos.y - y * 100) ** 2)

            const distances = ballsPos.map(data => {
                if (type === 'pichi') {
                    const nearestIndex = this.calcNearValueIndex(data.map(d => d.z), ptZ)
                    return calculateDistance(data[nearestIndex].x, data[nearestIndex].y)
                } else {
                    const lastPoint = data[data.length - 1]
                    return calculateDistance(lastPoint.x, lastPoint.y)
                }
            })

            return Math.max(...distances)
        },
        calcNearValueIndex (array, targetValue) {
            // console.log(array)
            const diff = []
            let index = 0
            array.forEach((val, i) => {
                diff[i] = Math.abs(targetValue - val)
                index = (diff[index] < diff[i]) ? index : i
            })
            return index
        },
        /**
         * @description pt対象の有効化無効化
         * @param index 比較球の添字
         * @param parm パラメータ boolen
         * **/
        setSavedBallPTFlag (index, parm) {
            this.savedBalls[index].ptFlag = parm
            this.setPichiTunnelSavedBall()

        },
        /**
         * @description pt対象の有効化無効化
         * @param index 基準球の添字
         * @param parm パラメータ boolen
         * **/
        setSavedStandardBallPTflag (index, parm) {
            this.savedStandardBall[0].ptFlag = parm
            console.log('this.savedStandardBall[0].ptFlag' + this.savedStandardBall[0].ptFlag)
            this.setPichiTunnelSavedStandardBall()
        },
        /**
         * function
         * @description 現在の基準球をタブとローカルストレージに保存する
         **/
        setPichiTunnelSavedStandardBall () {
            this.tabData.data[this.tabIndex].savedStandardBalls = this.savedStandardBall
            this.$ls.set(setting.sessionKey.pt1Tabs, this.tabData)
            this.$ls.set(setting.sessionKey.pichiTunnelBase, this.savedStandardBall)
            this.savedStandardBall = this.$ls.get(setting.sessionKey.pichiTunnelBase)
        },
        /**
         * function
         * @description 現在の比較球をタブとローカルストレージに保存する
         **/
        setPichiTunnelSavedBall () {
            this.tabData.data[this.tabIndex].savedBalls = this.savedBalls
            this.$ls.set(setting.sessionKey.pt1Tabs, this.tabData)
            this.$ls.set(setting.sessionKey.pichiTunnelCompar, this.savedBalls)
            this.savedBalls = this.$ls.get(setting.sessionKey.pichiTunnelCompar)
        },
        /**
         * function
         * 渡された投球情報を基に1ms毎の座標情報の配列をmax_time分の配列として返す
         * @param balls Array<Object> - 投球情報 APIの戻り値であるNineParamを持っている前提
         * @return Array<{t,x,y,z}> - 1ms毎の座標情報の配列
         * */
        calcBallPositionBymseconds (ballsInfo) {
            const result = []
            for (const d of ballsInfo){
                if (!d.ptFlag) {
                    continue
                }
                const nineParam = d.data.pitchingdata.NineParam
                const tmpArray = []
                const zoneTimemax = (nineParam.ZoneTime + 0.001) * 1000 | 0
                for (let i = 0; i < zoneTimemax; i += 1 | 0) {
                    let pos = {}
                    if (zoneTimemax - i > 1) {
                        pos.Time = Math.floor(i) / 1000
                    } else {
                        pos.Time = nineParam.ZoneTime
                    }
                    pos.x = nineParam.ax0 * Math.pow(pos.Time, 2) + nineParam.vx0 * pos.Time + nineParam.x0
                    pos.y = nineParam.ay0 * Math.pow(pos.Time, 2) + nineParam.vy0 * pos.Time + nineParam.y0
                    pos.z = nineParam.az0 * Math.pow(pos.Time, 2) + nineParam.vz0 * pos.Time + nineParam.z0
                    tmpArray.push({
                        t: pos.Time,
                        x: pos.x,
                        y: pos.z,
                        z: 18.44 - pos.y
                    })
                }
                result.push(tmpArray)
            }
            return result
        },
        pitchAnimate (num) {
            let lengthSum = 0
            this.timerID = setTimeout(() => {
                this.selectedBalls.forEach((d, i) => {
                    let pos = d.playPositions.shift()
                    if (typeof pos !== 'undefined') {
                        d.mesh.position.x = pos.x * 100
                        d.mesh.position.y = pos.y * 100
                        d.mesh.position.z = pos.z * 100
                        this.threeParts.nowLines[i].geometry.setDrawRange(0, this.threeParts.nowFrame + 1)
                    }
                    lengthSum += d.playPositions.length
                })
                if (lengthSum === 0) {
                    this.render()
                    clearTimeout(this.timerID)
                    this.playing = false
                    this.timerID = null
                    this.frameRate = 16 // スロー再生していた場合にフレームレートを戻す
                    // console.log(this.mode)
                    if (this.mode === 'tunnel') {
                        setTimeout(() => {
                            this.renderingTunnel('home')
                            this.render()
                        }, 10)
                    }
                } else {
                    this.threeParts.orbitControls.update()
                    this.render()
                    this.threeParts.nowFrame++
                    this.pitchAnimate(this.frameRate)
                }
            }, num)
        },
        next () {
            this.threeParts.nowID++
            this.singlePitch()
        },
        prev () {
            this.threeParts.nowID--
            this.singlePitch()
        },
        changeMode (mode) {
            this.mode = mode
            if (mode === 'compare') {
                this.getOnceSavedBalls()
            } else if (mode === 'atBat') {
                this.atBat_init()
            } else if (mode === 'tunnel') {
                this.getOnceSavedBalls()
            }
        },
        editMultiPositions (id, event) {
            console.log('editMultiPositions')
            let maxLength = 0
            this.enableMultiPos[id] = event.target.checked
            // コマ送りの最大コマを複数球の中から最多フレームをもつものに
            this.savedBalls.forEach((d, i) => {
                if (d.enabled && (this.multiBalls[i].length > maxLength)) {
                    maxLength = this.multiBalls[i].length
                    this.threeParts.nowMaxFrame = maxLength - 1
                }
            })
        },
        setViewPointAndSinglePitch (cx, cy, cz, lx, ly, lz, angle) {
            if (!this.playing) {
                this.changeCameraPos(cx, cy, cz)
                this.changeLookAt(lx, ly, lz)
                this.singlePitch()
                this.threeParts.orbitControls.update()
            }
            if (angle !== null) {
                this.currentAngle = angle
            }
            common.LOG('INFO', '3D軌跡', 'ユーザー操作/視点切り替え', angle)
        },
        setViewPointAndMultiPitch(cx, cy, cz, lx, ly, lz, angle) {
            const updateSlideValues = (x, y, z, lookX, lookY, lookZ) => {
                this.slidePitx = x
                this.slidePity = y
                this.slidePitz = z
                this.slidex = lookX
                this.slidey = lookY
                this.slidez = lookZ
            }
            if (angle) {
                this.currentAngle = angle

                if (angle === 'batterRight' || angle === 'batterLeft') {
                    const batterSet = this.batterPointSet[angle]
                    Object.assign(this.currentBatterPointSet, {
                        slideBatPositionXMin: batterSet.x.min,
                        slideBatPositionXMax: batterSet.x.max,
                        slideBatPositionZMin: batterSet.z.min,
                        slideBatPositionZMax: batterSet.z.max,
                        slideBatPointMin: batterSet.y.min,
                        slideBatPointMax: batterSet.y.max
                    })
                    this.slideBatx = cx
                    this.slideBaty = cy
                    this.slideBatz = cz
                } else if (angle === 'pitcher') {
                    Object.assign(this.currentBatterPointSet, {
                        slidePitPositionXMin: this.pitcherPointSet.x.min,
                        slidePitPositionXMax: this.pitcherPointSet.x.max,
                        slidePitPointMin: this.pitcherPointSet.y.min,
                        slidePitPointMax: this.pitcherPointSet.y.max
                    })
                }
            }

            updateSlideValues(cx, cy, cz, lx, ly, lz)

            if (!this.playing) {
                this.changeCameraPos(cx, cy, cz)
                this.changeLookAt(lx, ly, lz)
                this.multiPitch()
                this.threeParts.orbitControls.update()
            }

            common.LOG('INFO', '3D軌跡', 'ユーザー操作/視点切り替え', angle)
        },
        setCustomViewPoint () {
            if (this.currentAngle === 'batterRight' || this.currentAngle === 'batterLeft') {
                this.changeCameraPos(this.slideBatx, this.slideBaty, this.slideBatz)
            } else {
                this.changeCameraPos(this.slidePitx, this.slidePity, this.slidePitz)
            }
            this.changeLookAt(this.slidex, this.slidey, this.slidez)
            // this.multiPitch()
        },
        changeWard (ward) {
            if (ward === 'forward') {
                if (this.currentBatterPointSet.slideBatPositionZMin < this.slideBatz) {
                    this.slideBatz -= 1
                }
            } else if (ward === 'backward') {
                if (this.currentBatterPointSet.slideBatPositionZMax > this.slideBatz) {
                    this.slideBatz += 1
                }
            } else if (ward === 'leftward') {
                if (this.currentBatterPointSet.slideBatPositionXMin < this.slideBatx) {
                    this.slideBatx -= 1
                }
            } else if (ward === 'rightward') {
                if (this.currentBatterPointSet.slideBatPositionXMax > this.slideBatx) {
                    this.slideBatx += 1
                }
            }
        },
        resetWard (arr) {
            this.slideBatx = arr[0]
            this.slideBatz = arr[1]
        },
        submitBatterPosition (x, z) {
            this.slideBatx = x
            this.slideBatz = z
        },
        submitBatterPoint (y) {
            this.slideBaty = y
        },
        submitPitcherPosition (x) {
            this.slidePitx = x
        },
        submitPitcherPoint (y) {
            this.slidePity = y
        },
        changeBatterPoint (num) {
            this.slideBaty = num
        },
        changePitcherPosition (num) {
            this.slidePitx = num
        },
        changePitcherPoint (num) {
            this.slidePity = num
        },
        // 初回localStorageから比較球取得
        getOnceSavedBalls() {
            const isTunnelMode = this.mode === 'tunnel'
            if (isTunnelMode) this.tunnel_init()

            console.log('getOnceSavedBalls')

            const getSavedBallsFromStorage = (key, defaultValue = []) => {
                const data = this.$ls.get(key, defaultValue)
                return Array.isArray(data) ? data : []
            }
            this.savedBalls = getSavedBallsFromStorage(isTunnelMode ? 'PichiTunnelCompare' : 'savedBalls')
            this.savedStandardBall = getSavedBallsFromStorage(isTunnelMode ? 'PichiTunnelBase' : 'savedStandardBalls')
            console.log('this.savedBalls', this.savedBalls)
            console.log('this.savedStandardBall', this.savedStandardBall)
            const updateTrajectoryDatas = (balls) => {
                balls.forEach(d => {
                    this.trajectoryDatas[d.data.pitchingdata.PitchUID] = null
                })
            }
            updateTrajectoryDatas(this.savedBalls)
            updateTrajectoryDatas(this.savedStandardBall)
            if (Array.isArray(this.allBalls)) updateTrajectoryDatas(this.allBalls)

            this.getSavedBallIds()
            this.getSavedStandardBallIds()

            if (this.mode === 'compare') {
                this.handleCompareMode()
            } else if (this.mode === 'atBat') {
                this.handleAtBatMode()
            } else if (isTunnelMode) {
                this.handleTunnelMode()
            }

            console.log('init_done')
        },

        handleCompareMode() {
            this.handleReviewData()
            this.compare_init()
            const allBalls = this.getAllBalls()
            this.getPitchesData('getOnceSavedBalls', this.trajectoryDatas, allBalls)
        },

        handleReviewData() {
            const reviewData = this.$ls.get('PT2ComparisonReviewData')
            if (reviewData) {
                console.log('比較モードレビューのデータあり', reviewData.savedBalls)
                this.PTReviewBalls = this.processBalls(reviewData.savedBalls)
                this.PTReviewStandardBall = this.processBalls(reviewData.savedStandardBalls)
                reviewData.savedBalls.forEach(d => {
                    this.trajectoryDatas[d.data.pitchingdata.PitchUID] = null
                })
                reviewData.savedStandardBalls.forEach(d => {
                    this.trajectoryDatas[d.data.pitchingdata.PitchUID] = null
                })
            }
        },

        processBalls(balls) {
            return balls.map(d => ({
                ...d,
                enabled: true,
                ballColor: setting.typesOfBall_3d[d.data.pitchingdata.TaggedPitchType].fill
            }))
        },

        getAllBalls() {
            let allBalls = [...this.savedBalls, ...this.savedStandardBall]
            if (this.allBalls) allBalls = [...allBalls, ...this.allBalls]
            if (this.PTReviewBalls.length) allBalls = [...allBalls, ...this.PTReviewBalls]
            if (this.PTReviewStandardBall.length) allBalls = [...allBalls, ...this.PTReviewStandardBall]
            return allBalls
        },

        handleAtBatMode() {
            this.getBallData()
            this.atBat_init()
        },

        handleTunnelMode() {
            if (this.from === 'vsData') {
                this.getBallData()
                this.savedStandardBall = [...this.ball]
                this.$ls.set('PichiTunnelBase', this.savedStandardBall)
            }
            this.tunnel_init()
            this.calcTunnelPointInfo()
            if (!this.mountedFlag) {
                this.alertBallCountError()
            }
            const allBalls = this.getAllBalls()
            this.getPitchesData('getOnceSavedBalls', this.trajectoryDatas, allBalls)
        },
        calcTunnelPointInfo () {
            // ピッチトンネル、ホームプレート表示処理
            const pichiPos = this.calcTunnelPoint('pichi')
            const homePos = this.calcTunnelPoint('tunnel')
            this.pichiTunnelZ = pichiPos.deep
            this.pichiTunnelWidth = pichiPos.r
            this.homeTunnelZ = homePos.deep
            this.homeTunnelWidth = homePos.r
        },
        alertBallCountError () {
            const baseBallFlg = this.savedStandardBall[0] == null
            const compareBallFlg = this.savedBalls[0] == null
            if (baseBallFlg && compareBallFlg) {
                this.$alert('左下の新規作成ボタンから設定してください')
                return
            }
            if (baseBallFlg) {
                this.$alert('投球1が設定されていません')
                return
            }
            if (compareBallFlg) {
                this.$alert('投球2が設定されていません')

            }
        },
        /**
         * function
         * @parm type === 'pichi' ピッチトンネルの座標情報
         * * * type !== 'pichi' ホームプレートの座標情報
         *
         * */
        calcTunnelPoint (type) {
            const ballBasePositions = this.calcBallPositionBymseconds(this.savedStandardBall)
            const ballComparePositions = this.calcBallPositionBymseconds(this.savedBalls)
            return this.calcTunnelPosition(ballBasePositions, ballComparePositions, type)
        },
        /**
         * function
         * 基準球と比較球を入れ替える（セッションストレージの内容も）
         * */
        exchangeBaseBallAndSavedBall () {
            const tmpBaseData = this.$copy(this.savedStandardBall[0])
            const tmpCompareData = this.$copy(this.savedBalls[0])
            this.savedStandardBall[0] = this.$copy(tmpCompareData)
            this.savedBalls[0] = this.$copy(tmpBaseData)
            this.$ls.set('PichiTunnelBase', this.savedStandardBall)
            this.$ls.set('PichiTunnelCompare', this.savedBalls)
            this.$alert(`基準球の球速 < 比較球の球速 なので
        基準球と比較球を入れ替えます
        入れ替え前の基準球の速度 ${Math.round(this.savedBalls[0].data.pitchingdata.RelSpeed / 100) / 10}
        入れ替え前の比較球の速度 ${Math.round(this.savedStandardBall[0].data.pitchingdata.RelSpeed / 100) / 10}`)

        },
        // localStorageから比較球取得
        getSavedBalls () {
            console.log('getSavedBalls')
            this.savedBalls = this.$ls.get('savedBalls',[])
        },
        getSavedBallIds () {
            this.currentSavedBallsId = this.savedBalls?.map((d) => d.data.id)
        },
        // localStorageから基準球取得
        getSavedStandardBalls () {
            console.log('getSavedStandardBalls')
            this.savedStandardBall = this.$ls.get('savedStandardBalls',[])
        },
        getSavedStandardBallIds () {
            let tmpData = []
            this.savedStandardBall.forEach((d) => {
                tmpData.push(d.data.id)
            })
            this.currentSavedStandardBallId = tmpData
        },
        // localStorageに比較球セット
        setSavedBalls () {
            console.log('setSavedBalls')
            this.$ls.set('savedBalls', this.savedBalls)
            this.savedBalls = this.$ls.get('savedBalls',[])
            this.getSavedBallIds()
        },
        // localStorageに基準球セット
        setSavedStandardBalls () {
            console.log('savedStandardBall')
            this.$ls.set('savedStandardBalls', this.savedStandardBall)
            this.savedStandardBall = this.$ls.get('savedStandardBalls')
            this.getSavedStandardBallIds()
        },
        // 比較球削除→localStorageにも反映
        removeSavedBall (index) {
            console.log('removeSavedBall')
            let deleteBall = this.savedBalls[index]
            this.savedBalls.splice(index, 1)
            this.setSavedBalls()
            if (this.baseBallIndex >= this.savedBalls.length) {
                this.baseBallIndex = this.savedBalls.length - 1
            } else if (this.savedBalls === 0) {
                this.baseBallIndex = 0
            }
            common.LOG('INFO', '3D軌跡 比較モード トップ', '比較球 削除', deleteBall.id, deleteBall.pitcher.name)
        },
        // 基準球削除→localStorageにも反映
        removeSavedStandardBall (index) {
            console.log('removeSavedStandardBall')
            this.savedStandardBall.splice(index, 1)
            this.setSavedStandardBalls()
        },
        changeBaseBall (index) {
            console.log('changeBaseBall')
            this.baseBallIndex = index
        },
        toggleSavedBall (bool, index) {
            if (this.threeListSortMode === 2) {
                // ピッチトンネル比較モードレビュー球の表示・非表示切替
                this.PTReviewBalls[index].enabled = bool
            } else {
                this.savedBalls[index].enabled = bool
                if (this.mode === 'tunnel') {
                    this.setPichiTunnelSavedBall()
                } else {
                    this.setSavedBalls()
                }
            }
            // this.$ls.set('savedBalls', this.savedBalls)
        },
        toggleSavedStandardBall (bool, index, target = '') {
            if (this.threeListSortMode === 2) {
                // ピッチトンネル比較モードレビュー球の表示・非表示切替
                this.PTReviewStandardBall[index].enabled = bool
            } else {
                if (this.mode === 'tunnel') {
                    this[target][index].enabled = bool
                    this.setPichiTunnelSavedStandardBall()
                } else {
                    this.savedStandardBall[index].enabled = bool
                    this.setSavedStandardBalls()
                }
            }
            // this.$ls.set('savedStandardBalls', this.savedStandardBall)
        },
        // ピッチトンネル比較モードレビューを終了し、PTに戻る
        PTReviewBack () {
            console.log('PTReviewBack')
            const reviewData = (this.$ls.get('PT2ComparisonReviewData'))
            if (reviewData && reviewData.PT2Search) {
                this.$ls.set('PT2Search', reviewData.PT2Search)
            }
            this.$router.push('PitchiTunnelSearch')
            this.threeListSortMode = 0
            this.PTReviewBalls = []
            this.PTReviewStandardBall = []
            this.$ls.remove('PT2ComparisonReviewData')
        },
        // ピッチトンネル比較モードレビューの投球データを保存し、タブに追加、ピッチトンネル表示に切り替える
        PTReviewSave () {
            console.log('PTReviewSave')
            const tabData = this.$ls.get('PT1Tabs')
            if (tabData.data.length >= 5) {
                this.$alert('投球データが5件登録されています')
                return false
            }
            console.log('tabData', tabData.index)
            const tabDataLength = tabData.data.length
            tabData.index = tabDataLength
            const reviewData  = this.$ls.get('PT2ComparisonReviewData')
            if (reviewData) {
                tabData.data.push(reviewData)
            }
            this.threeListSortMode = 0
            this.PTReviewBalls = []
            this.PTReviewStandardBall = []
            this.$ls.remove('PT2ComparisonReviewData')
            this.$ls.set('PT1Tabs', tabData)
            this.changeMode('tunnel')
            this.changeTab(tabDataLength)
        },
        getResultText (result) {
            let text = ''
            if (result === 'inplay') {
                text = this.setting.typesOfResult['inplay'][result].name
            } else {
                text = this.setting.typesOfResult[result].name
            }
            return text
        },
        getBallText (ball) {
            let text = ''
            text = this.setting.typesOfBall_3d[ball].name
            return text
        },
        openBatterPanel () {
            this.batterPanelState = true
            common.LOG('INFO', '3D軌跡', 'ユーザー操作/視点切り替え/打者設定', 'ON')
        },
        openPitcherPanel () {
            this.pitcherPanelState = true
            common.LOG('INFO', '3D軌跡', 'ユーザー操作/視点切り替え/投手設定', 'ON')
        },
        closeBatterPanel () {
            this.batterPanelState = false
            common.LOG('INFO', '3D軌跡', 'ユーザー操作/視点切り替え/打者設定', 'OFF')
        },
        closePitcherPanel () {
            this.pitcherPanelState = false
            common.LOG('INFO', '3D軌跡', 'ユーザー操作/視点切り替え/投手設定', 'OFF')
        },
        // 基準球、比較球検索モーダル
        openSearchModal (type) {
            this.searchModalFlg = true
            this.searchModalType = type
        },
        closeSearchModal () {
            this.searchModalFlg = false
        },
        // listから表示方法プルダウンの変更
        setListSortMode (num) {
            this.threeListSortMode = num
        },
        // メッセージモーダル
        messageModalOn (message) {
            this.message = message
            this.messageModalShow = true
            window.clearTimeout(this.messageTimeout)
            this.messageTimeout = window.setTimeout(this.messageModalOff, 2000)
        },
        messageModalOff () {
            this.messageModalShow = false
        },
        // ローディング
        loadingOn (message) {
            console.log('loadingOn', message)
            if (message !== undefined) {
                this.loadingMessage = message
            } else {
                this.loadingMessage = ''
            }
            this.loadingShow = true
        },
        loadingOff () {
            this.loadingShow = false
        }
    }
}
</script>
